import axios from 'axios'
// import store from '../store'
import tryGet from "../../utils/try-get";
import { getDayMonthFromDate } from "../../utils/datetime-handling";
import { DISTANCE_UNITS } from "../../constants/options";
import { DEFAULT_DATEPICKER_FIELD } from "../../constants/default-values";

const state = {
  website: 'https://nanny.enginehire.io/',
  platformURL: 'https://agency.enginehire.io/',
  agencyHumanName: 'Enginehire',
  agencyPublic: {},
  loadAgencyReqNumber: 0,
  reloadAgencyReqNumber: 0,
  dashboardv2: false
};

const mutations = {
  setAgencyPublic(state, agencyPublic) {
    state.agencyPublic = agencyPublic;
  },
  increaseLoadAgencyReqNumber(state, payload) {
    state.loadAgencyReqNumber += payload;
  },
  increaseReloadAgencyReqNumber(state, payload) {
    state.reloadAgencyReqNumber += payload;
  },
  changeAgencyType(state, payload) {
    state.agencyPublic.type = payload;
  },
  setDashboardV2(state, payload) {
    state.dashboardv2 = payload
  },
};

const actions = {
  setAgencyPublic({ commit }, payload) {
    commit("setAgencyPublic", payload);
  },
  increaseLoadAgencyReqNumber({ commit }, payload) {
    commit("increaseLoadAgencyReqNumber", payload);
  },
  increaseReloadAgencyReqNumber({ commit }, payload) {
    commit("increaseReloadAgencyReqNumber", payload);
  },
  async setAgencyType(context, payload) {
    const response = await axios.put(`/optimum/agency_type/update/${payload.agencyId}/`, { type: payload.agencyType });
    if (response.status === 200) {
      context.commit("changeAgencyType", response.data.type)
      return response;
    }
  }
};

const getters = {
  website(state) {
    return state.website
  },
  platformURL(state) {
    return state.platformURL
  },
  agencyPublic(state) {
    return state.agencyPublic
  },
  agencyLocations(state) {
    if (state.agencyPublic) {
      return state.agencyPublic.locations;
    }
    return null;
  },
  agencyHolidays(state) {
    if (state.agencyPublic) {
      return state.agencyPublic.holidays;
    }
    return null;
  },
  hasCandidateIntroVideo(state) {
    if (state.agencyPublic) {
      return state.agencyPublic.candidate_intro_videos;
    }
    return false;
  },
  businessHours(state) {
    if (state.agencyPublic && state.agencyPublic.public_advance_setting) {
      return state.agencyPublic.public_advance_setting.business_hours;
    }
    return null;
  },
  // List of holiday by MM-dd
  agencyHolidayDates(state, getters) {
    const holidays = getters.agencyHolidays;
    if (!holidays) {
      return [];
    }
    return holidays.filter(item => item.date).map(item => getDayMonthFromDate(item.date));
  },
  agencyHumanName(state) {
    if (state.agencyPublic) {
      return state.agencyPublic.human_name;
    }
    return "";
  },
  agencyCurrency(state) {
    if (state.agencyPublic) {
      return state.agencyPublic.currency;
    }
    return "USD"; // Default is USD
  },
  agencyLanguages(state) {
    if (state.agencyPublic) {
      return state.agencyPublic.languages;
    }
    return null;
  },
  authorizeNetClientKey: state => tryGet(() => state.agencyPublic.authorize_net_params.clientKey) || '',
  authorizeNetAPILoginID: state => tryGet(() => state.agencyPublic.authorize_net_params.loginID) || '',
  disclaimerTextBookingSection: state => tryGet(() => state.agencyPublic.public_advance_setting.disclaimer_text_booking_section) || '',
  doNotShowDuplicatedDocumentsUpdatingStatus: state => tryGet(() => state.agencyPublic.public_advance_setting.do_not_show_duplicated_documents_updating_status) || false,
  agencyCurrencySign(state, getters) {
    const agencyCurrency = getters.agencyCurrency;
    let symbol;
    switch (agencyCurrency) {
      case "USD":
        symbol = "$"
        break;
      case "AUD":
        symbol = "A$"
        break;
      case "BGN":
        symbol = "Лв."
        break;
      case "BRL":
        symbol = "R$"
        break;
      case "CAD":
        symbol = "C$"
        break;
      case "CZK":
        symbol = "Kč"
        break;
      case "DKK":
        symbol = "kr"
        break;
      case "EUR":
        symbol = "€"
        break;
      case "GBP":
        symbol = "£"
        break;
      case "HKD":
        symbol = "HK$"
        break;
      case "HUF":
        symbol = "Ft"
        break;
      case "INR":
        symbol = "₹"
        break;
      case "JPY":
        symbol = "¥"
        break;
      case "MXN":
        symbol = "Mex$"
        break;
      case "MYR":
        symbol = "RM"
        break;
      case "NOK":
        symbol = "kr"
        break;
      case "NZD":
        symbol = "NZ$"
        break;
      case "PLN":
        symbol = "zł"
        break;
      case "RON":
        symbol = "L"
        break;
      case "SEK":
        symbol = "kr"
        break;
      case "SGD":
        symbol = "S$"
        break;
      default:
        symbol = agencyCurrency ? agencyCurrency : "$";
        break;
    }
    return symbol;
  },
  agencyLogoHeight(state, getters, rootState) {
    const agency = rootState.agency.agencyPublic;
    if (agency && agency.logo_height) {
      return agency.logo_height;
    }
    return 60; // Default is 60px
  },
  agencyLogoHeightInPx(state, getters) {
    return getters.agencyLogoHeight + 'px';
  },
  stripeAccountId(state, getters, rootState) {
    const agency = rootState.authentication.agency;
    if (
      agency &&
      agency.stripe_account_id) {
      return agency.stripe_account_id;
    }
    return '';
  },
  useModalInApplicationForm(state) {
    const agency = state.agencyPublic;
    if (
      agency &&
      agency.public_advance_setting && agency.public_advance_setting.use_modal_application_form != null) {
      return agency.public_advance_setting.use_modal_application_form
    }
    return true; // deafult is true
  },
  chooseAddOptionSelectively(state) {
    const agency = state.agencyPublic;
    if (
      agency &&
      agency.public_advance_setting && agency.public_advance_setting.choose_add_option_selectively != null) {
      return agency.public_advance_setting.choose_add_option_selectively
    }
    return false; // deafult is false
  },
  disableWarningCancelPopupApplicationForm(state) {
    const agency = state.agencyPublic;
    if (
      agency &&
      agency.public_advance_setting && agency.public_advance_setting.disable_confirm_cancel_popup_application_form != null) {
      return agency.public_advance_setting.disable_confirm_cancel_popup_application_form
    }
    return false; // deafult is false
  },
  twilioPhoneNumber(state, getters, rootState) {
    const agency = rootState.authentication.agency;
    if (
      agency &&
      agency.twilio_phone_number) {
      return agency.twilio_phone_number;
    }
    return "";
  },
  agencyType(state, getters, rootState) {
    const agency = rootState.authentication.agency;
    if (agency && agency.type) {
      return agency.type;
    }
    return "";
  },
  agencyCountries(state, getters, rootState) {
    const agency = rootState.authentication.agency;
    if (agency && agency.countries) {
      return agency.countries.map(country => {
        const countryObj = rootState.listCountries.find(item => item.code === country);
        if (countryObj) {
          return countryObj.name;
        }
        return country;
      });
    }
    return [];
  },
  agencyDistanceUnitLabel(state, getters) {
    const option = DISTANCE_UNITS.find(option => option.value === getters.agencyDistanceUnit);
    if (option) {
      return option.label;
    }
    return "Mile"
  },
  getDashboardV2(state, _) {
    return state.dashboardv2;
  },
  wordUsedForCandidate: state => tryGet(() => state.agencyPublic.public_advance_setting.word_used_for_candidate) || 'Candidate',
  wordUsedForClient: state => tryGet(() => state.agencyPublic.public_advance_setting.word_used_for_client) || 'Client',
  wordUsedForCandidates: state => tryGet(() => state.agencyPublic.public_advance_setting.word_used_for_candidates) || 'Candidates',
  wordUsedForClients: state => tryGet(() => state.agencyPublic.public_advance_setting.word_used_for_clients) || 'Clients',
  wordUsedForShiftJobCalendar: state => tryGet(() => state.agencyPublic.public_advance_setting.word_used_for_shift_job_calendar) || "Shift Job Calendar",
  wordUsedForJobPlacement: state => tryGet(() => state.agencyPublic.public_advance_setting.word_used_for_job_placement) || "Placement Jobs",
  agencyDistanceUnit: state => tryGet(() => state.agencyPublic.public_advance_setting.distance_unit) || "miles",
  datepickerDefaultFormat: state => tryGet(() => state.agencyPublic.public_advance_setting.datepicker_default_format) || DEFAULT_DATEPICKER_FIELD.FORMAT,
  datepickerDefaultPlaceholder: state => tryGet(() => state.agencyPublic.public_advance_setting.datepicker_default_placeholder) || DEFAULT_DATEPICKER_FIELD.PLACEHOLDER,
  phoneDefaultFormat: state => tryGet(() => state.agencyPublic.public_advance_setting.phone_default_format),
  agencyPredefinedOptionList: state => tryGet(() => state.agencyPublic.public_advance_setting.predefined_option_list),
  notifyAgencyUserEditDocumentAdditionalInfo: (state, getters, rootState) => tryGet(() => rootState.authentication.agency.advance_setting.notify_agency_user_edit_document_additional_info) || false,
  showMinEntriesRequiredApplicationForm: state => tryGet(() => state.agencyPublic.public_advance_setting.show_min_entries_required_application_form) || false,
};

export default {
  state,
  mutations,
  actions,
  getters,
}



// WEBPACK FOOTER //
// ./src/store/modules/agency.js